import { unstable_useBlocker as useBlocker } from 'react-router-dom'

interface Props {
    when: boolean
    message: () => void
}

function Prompt({ when, message }: Props) {
    useBlocker(() => {
        if (when) {
            message()
            return true
        }
        return false
    })

    return <div key={String(when)} />
}

export default Prompt
